export default __webpack_public_path__ + "static/media/048-grandmother.cd0aacd8.png";